import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
   Grid,
   GridItem,
   FormControl,
   Input,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   Checkbox,
   Textarea,
   useDisclosure,
   Table,
   Thead,
   Tr,
   Th,
   Tbody,
   Td,
   Text,
   Flex,
} from '@chakra-ui/react';
import '../../../theme/theme';
import editIcon from 'assets/img/nfts/edit.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
   getAdjustedVoucher,
   adjustmentEditVoucherDetails,
   updateVoucher,
   getBankVoucher,
   voucherNextPrev,
   getOneVoucher,
   lastVoucherDetails,
   checkLastDocNumberVoucher,
} from '../../../redux/actions/voucher';
import { getAccount, getAccountById, getAccountForCashBank } from '../../../redux/actions/account';
import { toast } from 'react-toastify';
import { MdInfoOutline } from 'react-icons/md';
import { DAYBOOK_TYPE } from 'constants';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import Swal from 'sweetalert2';
import { useUser, useGlobal } from 'contexts';
import { getFinancialYears } from '../../../redux/actions/dashboard';
import moment from 'moment';
import TextareaField from 'components/ui/TextareaField';
import { getDaybook, getDaybookForPayments } from '../../../redux/actions/daybook';
import { getItem } from '../../../redux/actions/item';

const PaymentcaseFormEdit = ({
   isOutstandingModalOpen,
   setIsOutstandingModalOpen,
   daybookTypeData,
   validationSchema,
   errors,
   setErrors,
   isBankPageTrue,
   selectedAccount,
   setSelectedAccount,
   userData,
   type,
   isEditMode,
   receivedAmount,
   setReceivedAmount,
   totalPendingAccount,
   setTotalPendingAccount,
   formData,
   setFormData,
   transactionType,
   handleClearData,
   pendingVoucher,
   setPendingVoucher,
   currentPage,
   limit,
   companyId,
   searchQuery,
   sorting,
   pagination,
   fetchBankVoucherData,
}) => {
   const [currentRow, setCurrentRow] = useState({});
   const dispatch = useDispatch();
   const [focusedInput, setFocusedInput] = useState('');
   const [isProcessing, setIsProcessing] = useState(false);
   const processingRef = useRef(false);
   const adjustedVoucher = useSelector((state) => state.voucher?.adjustedVoucher || []);
   const txnDateRef = useRef(null);
   const daybookRef = useRef(null);
   const accountRef = useRef(null);
   const notesRef = useRef(null);
   const createRef = useRef(null);
   const cancelRef = useRef(null);
   const docNumberRef = useRef(null);
   const receivedAmtRef = useRef(null);
   const chequeNoRef = useRef(null);
   const chequeDateRef = useRef(null);
   const lastAdjustmentParamsRef = useRef(null);
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   // const targetGlGroup = glGroup?.find((group) => group.code === 'K');
   const lastVoucherData = useSelector((state) => state.voucher?.lastVoucher || null);
   const adjustmentVoucher = useSelector((state) => state.voucher?.adjustmentVoucher || []);
   const adjustmentVoucherBalanace = useSelector((state) => state.voucher?.adj_voucher_balance || null);
   const [isDocNumberFocused, setIsDocNumberFocused] = useState(false);
   const account = useSelector((state) => state?.account?.listForCashBank || []);
   const [isNavigating, setIsNavigating] = useState(false);
   const singleVoucher = useSelector((state) => state.voucher?.single || null);
   // let pendingVoucher = adjustmentVoucher;
   const [isTransaction, setIsTransaction] = useState(true);
   // const userData = useSelector((state) => state?.account?.list || []);
   const location = useLocation();
   const isBankPage = isBankPageTrue || location.pathname.includes('/bank');
   const textColor = useColorModeValue('gray.800', 'white');
   const { isOpen, onOpen, onClose } = useDisclosure();
   let accountAmt;
   const daybookbalance = daybookTypeData.find((item) => item.id === formData?.daybookId)?.bal ?? null;
   // const [checkedItems, setCheckedItems] = useState([false, false, false]);
   const [checkedItems, setCheckedItems] = useState([]);
   const [totalAmount, setTotalAmount] = useState(0);
   const [isEditingAmount, setIsEditingAmount] = useState(false);
   const [tempReceivedAmount, setTempReceivedAmount] = useState('');
   const [isEditing, setIsEditing] = useState(false);
   const [editingValues, setEditingValues] = useState({});
   const { user } = useUser();
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   useEffect(() => {
      const handleKeyDown = async (event) => {
         // Only handle PageUp/PageDown when docNumber input is focused and not already navigating
         if (!isDocNumberFocused || isNavigating) return;

         if (event.key === 'PageDown' || event.keyCode === 34) {
            event.preventDefault();
            event.stopPropagation();
            await handleVoucherNavigation('prev');
         }

         if (event.key === 'PageUp' || event.keyCode === 33) {
            event.preventDefault();
            event.stopPropagation();
            await handleVoucherNavigation('next');
         }
      };

      if (isDocNumberFocused && isOutstandingModalOpen) {
         document.addEventListener('keydown', handleKeyDown);
         return () => {
            document.removeEventListener('keydown', handleKeyDown);
         };
      }
   }, [isDocNumberFocused, isOutstandingModalOpen, isNavigating]);

   // Single function to handle all voucher navigation logic
   const handleVoucherNavigation = async (direction) => {
      if (!formData.id || isNavigating) return;

      setIsNavigating(true);

      try {
         // Step 1: Get next/prev voucher IDs
         const params = {
            id: parseInt(formData.id),
            type: type,
            companyId: companyId,
            daybookId: formData.daybookId,
         };

         // Dispatch and wait for the navigation data
         // await dispatch(voucherNextPrev(params));
         const response = await dispatch(voucherNextPrev(params));

         // Get the target voucher ID based on direction
         let targetVoucherId = null;
         if (direction === 'prev' && response.data?.prev !== null) {
            targetVoucherId = response.data.prev;
         } else if (direction === 'next' && response.data?.next !== null) {
            targetVoucherId = response.data.next;
         }

         if (!targetVoucherId) {
            toast.error('No Entries Available');
            return;
         }

         // Step 2: Get the complete voucher details
         // await dispatch(getOneVoucher(targetVoucherId));
         const singleVoucher1 = await dispatch(getOneVoucher(targetVoucherId));

         // Step 3: Update form data with the new voucher (only one state update)
         if (singleVoucher) {
            const newFormData = {
               id: singleVoucher1?.data?.id,
               daybookId: singleVoucher1?.data?.daybookId,
               accountId: singleVoucher1?.data?.accountId,
               amount: singleVoucher1?.data?.amount,
               companyId: singleVoucher1?.data?.companyId,
               docNumber: singleVoucher1?.data?.docNumber,
               txnDate: singleVoucher1?.data?.txnDate,
               txnType: singleVoucher1?.data?.txnType,
               userNote: singleVoucher1?.data?.userNote,
               balance: singleVoucher1?.data?.balance,
               GSTAmount: singleVoucher1?.data?.GSTAmount,
               GSTSubTxnType: singleVoucher1?.data?.GSTSubTxnType,
               GSTTxnType: singleVoucher1?.data?.GSTTxnType,
               HSNSACId: singleVoucher1?.data?.HSNSACId,
               bankBranchId: singleVoucher1?.data?.bankBranchId,
               daybookName: singleVoucher1?.data?.daybookName,
               accountName: singleVoucher1?.data?.accountName,
               isRCM: singleVoucher1?.data?.isRCM,
               particulars: singleVoucher1?.data?.particulars,
               chequeDate: singleVoucher1?.data?.chequeDate,
               chequeNo: singleVoucher1?.data?.chequeNo,
               clearingDate: singleVoucher1?.data?.clearingDate,
            };

            // Single state update
            setSelectedAccount(singleVoucher1?.data?.accountId);
            setFormData(newFormData);

            // Step 4: Load adjustment details if needed (only one call)
            if (isTransaction) {
               await dispatch(
                  adjustmentEditVoucherDetails({
                     companyId: parseInt(singleVoucher1?.data?.companyId),
                     accountId: parseInt(singleVoucher1?.data?.accountId),
                     txnType: singleVoucher1?.data?.txnType,
                     voucherId: singleVoucher1?.data?.id,
                  }),
               );
               await dispatch(getAccountForCashBank({ compId: user?.loginhistory?.companyId, status: true }));

               const accountAmt = account.find((item) => item.id === singleVoucher1?.data?.accountId)?.amt ?? null;
               setTotalPendingAccount(accountAmt);
            }
         }
      } catch (error) {
         console.error(`Error in ${direction} navigation:`, error);
         toast.error(`Error navigating to ${direction === 'prev' ? 'previous' : 'next'} voucher`);
      } finally {
         setIsNavigating(false);

         // Keep focus on docNumber input
         setTimeout(() => {
            docNumberRef.current?.focus();
         }, 100);
      }
   };

   const filteredAccountData = useMemo(() => {
      if (!formData.daybookId || !daybookTypeData || !account) {
         return account || [];
      }

      // Find the selected daybook
      const selectedDaybook = daybookTypeData.find((daybook) => daybook.id === formData.daybookId);

      if (!selectedDaybook || !selectedDaybook.accountId) {
         return account || [];
      }

      // Filter out the account that matches the daybook's accountId
      return account.filter((account) => account.id !== selectedDaybook.accountId);
   }, [formData.daybookId, daybookTypeData, account]);

   // Add this useEffect to handle account clearing when daybook changes
   useEffect(() => {
      if (formData.daybookId && (selectedAccount || formData.accountId) && daybookTypeData) {
         const selectedDaybook = daybookTypeData.find((daybook) => daybook.id === formData.daybookId);

         // Get the current account ID (either from selectedAccount or formData)
         const currentAccountId = selectedAccount?.id || selectedAccount || formData.accountId;

         // If the currently selected account is the same as the daybook's account, clear it
         if (selectedDaybook && selectedDaybook.accountId === currentAccountId) {
            setSelectedAccount(null);
            setFormData((prev) => ({
               ...prev,
               accountId: null,
            }));

            // Clear any related data
            setPendingVoucher([]);
            setTotalPendingAccount(0);
            setReceivedAmount(0);
         }
      }
   }, [formData.daybookId, selectedAccount, formData.accountId, daybookTypeData]);

   // Remove all the existing voucher navigation useEffects and replace with this simplified version
   // Only keep this one useEffect for initial voucher loading
   useEffect(() => {
      if (formData?.id && !isNavigating) {
         dispatch(getOneVoucher(formData?.id));
      }
   }, [dispatch, formData?.id]);

   useEffect(() => {
      // Get the list of accounts from userData
      const accounts = userData;

      // Only run this when accounts are available and formData.accountId exists
      if (accounts?.length > 0 && formData?.accountId && !selectedAccount) {
         // Find the account in the list that matches formData.accountId
         const accountMatch = accounts.find((acc) => acc.id?.toString() === formData.accountId?.toString());

         if (accountMatch) {
            // Format the account object as expected by GstDropDownPayment
            const formattedAccount = {
               value: accountMatch.id?.toString() || 'unknown-id',
               name: accountMatch.name || 'Unknown Name',
               mobile: accountMatch.mobile || 'No number available',
               gstRegNo: accountMatch.gstRegNo || 'No number available',
               panNo: accountMatch.panNo || 'No number available',
               label: accountMatch.name?.toUpperCase(),
               ...accountMatch, // Include all original account properties
            };

            // Set this as the selected account
            setSelectedAccount(formattedAccount);
         }
      }
   }, [userData, formData.accountId, selectedAccount, formData.txnType, setSelectedAccount]);

   useEffect(() => {
      setTimeout(() => {
         txnDateRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter') {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      } else if (e.key === 'Tab') {
         e.preventDefault();
         if (e.shiftKey) {
            preRef?.current?.focus();
         } else {
            nextRef?.current?.focus();
         }
      }
   };
   const targetGlGroup = glGroup?.find((group) => group.code === (transactionType === 'receive' ? 'K' : 'E'));

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== txnDateRef.current) {
               // Focus txnDateRef if not already focused
               txnDateRef.current?.focus();
            } else {
               // If already focused, go back
               handleClearData(); // cleanup
               setIsOutstandingModalOpen(false);
            }
            e.stopPropagation();
            e.preventDefault();
         }
      };

      window.addEventListener('keydown', handleKeyDown, true);
      return () => {
         window.removeEventListener('keydown', handleKeyDown, true);
      };
   }, []);

   useEffect(() => {
      // Use singleVoucher.accountId if available, otherwise fall back to formData.accountId
      const accountIdToUse = singleVoucher?.accountId || formData?.accountId;
      const companyIdToUse = singleVoucher?.companyId || formData?.companyId;
      const txnTypeToUse = singleVoucher?.txnType || formData?.txnType;
      const voucherIdToUse = singleVoucher?.id || formData?.id;

      if (accountIdToUse && voucherIdToUse && !isNavigating) {
         const currentParams = {
            companyId: parseInt(companyIdToUse),
            accountId: parseInt(accountIdToUse),
            txnType: txnTypeToUse,
            voucherId: voucherIdToUse,
         };

         // Create a string representation for easy comparison
         const currentParamsString = JSON.stringify(currentParams);
         const lastParamsString = lastAdjustmentParamsRef.current
            ? JSON.stringify(lastAdjustmentParamsRef.current)
            : null;

         // Check if the parameters are different from the last call
         if (currentParamsString !== lastParamsString && !isNavigating) {
            // Update the last params before making the call
            lastAdjustmentParamsRef.current = currentParams;

            setTimeout(() => {
               dispatch(adjustmentEditVoucherDetails(currentParams));
               dispatch(getAccountForCashBank({ compId: user?.loginhistory?.companyId, status: true }));
            }, 200);
         } else {
         }
      }
   }, [dispatch, formData?.id, formData?.txnType, formData.accountId, formData.companyId, singleVoucher, isNavigating]);

   useEffect(() => {
      if (adjustmentVoucher?.length > 0) {
         setPendingVoucher(adjustmentVoucher);
      } else {
         setPendingVoucher([]); // clear if not present
      }
   }, [adjustmentVoucher, formData.id, formData.accountId, formData.docNumber]);

   useEffect(() => {
      // When a new account is selected, preserve the typed amount
      if (selectedAccount && receivedAmtRef.current) {

         // Small delay to ensure DOM is ready
         setTimeout(() => {
            if (receivedAmtRef.current) {
               receivedAmtRef.current.focus();

               // If there's an amount in formData, set it
               if (formData.amount && formData.amount > 0) {
                  setIsEditingAmount(true);
                  setTempReceivedAmount(formData.amount);
                  setReceivedAmount(formData.amount);
               }
            }
         }, 150);
      }
   }, [selectedAccount]);

   const handleAccountSelect = (selected) => {

      if (selected) {
         // Store the current amount before resetting
         const currentAmount = formData.amount || 0;

         // Update formData with the selected account ID
         setFormData({
            ...formData,
            accountId: selected.id ? selected.id : selected,
            amount: currentAmount, // Keep the current amount
         });

         // If transactions should be loaded
         if (isTransaction) {
            dispatch(
               adjustmentEditVoucherDetails({
                  companyId: parseInt(formData.companyId),
                  accountId: parseInt(selected),
                  txnType: formData.txnType,
                  voucherId: formData.id,
               }),
            );
            dispatch(getAccountForCashBank({ compId: user?.loginhistory?.companyId, status: true }));

            const accountAmt = account.find((item) => item.id === selected)?.amt ?? null;
            setTotalPendingAccount(accountAmt);

            // Focus on amount field after account is selected
            setTimeout(() => {
               if (receivedAmtRef.current) {
                  receivedAmtRef.current.focus();
                  // Select all text for easy editing
                  receivedAmtRef.current.select();
               }
            }, 100);
         }
      } else {
         // Handle clearing the selection
         setFormData({
            ...formData,
            accountId: null,
            amount: formData.amount || 0, // Keep the amount
         })

      }
   };

   // Inside the useEffect that handles pendingVoucher changes
   useEffect(() => {
      if (pendingVoucher.length > 0) {
         // Initialize checked items based on isAdjusted or isAdjustment property
         const initialCheckedItems = pendingVoucher.map(
            (voucher) => voucher.isAdjusted === true || voucher.isAdjustment === true,
         );
         setCheckedItems(initialCheckedItems);

         // Initialize editing values with voucher.amount for each adjusted voucher
         const initialEditingValues = pendingVoucher.reduce((acc, voucher, index) => {
            if (voucher.isAdjusted === true || voucher.isAdjustment === true) {
               // Use the amount value for adjusted vouchers
               acc[index] = parseFloat(voucher.amount);
            }
            return acc;
         }, {});

         // Set editing values
         setEditingValues(initialEditingValues);

         // Calculate initial total received amount
         const initialTotal =
            formData.amount !== undefined && formData.amount !== null
               ? formData.amount
               : pendingVoucher.reduce((total, voucher, index) => {
                  return voucher.isAdjusted === true || voucher.isAdjustment === true
                     ? total + parseFloat(voucher.amount)
                     : total;
               }, 0);

         // Set received amount to the initial total
         setReceivedAmount(initialTotal);
         setTempReceivedAmount(initialTotal);

         // IMPORTANT: Ensure formData.amount is preserved
         if (formData.amount !== undefined && formData.amount !== null && formData.amount !== '') {
            setReceivedAmount(formData.amount);
            setTempReceivedAmount(formData.amount);
         }

         const pendingTotalAmount = pendingVoucher.reduce((total, voucher) => {
            return total + parseFloat(voucher.netAmount);
         }, 0);

         // Calculate total of adjusted amounts
         const initialOutstandingAmountTotal = pendingVoucher.reduce((total, voucher) => {
            return voucher.isAdjusted === true || voucher.isAdjustment === true
               ? total + parseFloat(voucher.amount)
               : total;
         }, 0);

         setTotalAmount(initialOutstandingAmountTotal);
         setTotalPendingAccount(pendingTotalAmount);
      }
   }, [
      pendingVoucher,
      setReceivedAmount,
      formData?.amount,
      formData?.docNumber,
      singleVoucher?.docNumber,
      singleVoucher?.accountId,
   ]);

   useEffect(() => {
      // Only add the event listener when the modal is open
      if (!isOutstandingModalOpen) return;

      const handleKeyDown = (event) => {
         // Check for Ctrl+S (or Cmd+S on Mac)
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            // Completely prevent default browser behavior
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            // Trigger form submit
            handleFormSubmit();
            // Prevent any other handlers from running
            return false;
         }
      };

      // Add event listeners at multiple levels for complete coverage
      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [isOutstandingModalOpen, formData, formData.id, receivedAmount, isTransaction, editingValues]);

   const handleFocus = (id) => {
      setFocusedInput(id);
   };

   const handleBlur = () => {
      setFocusedInput('');
   };

   const handleDynamicCheckboxChange = useCallback(
      (index, checked) => {
         if (isEditingAmount) return;

         setCheckedItems((prevCheckedItems) => {
            const newCheckedItems = [...prevCheckedItems];
            const currentEntry = pendingVoucher[index];

            // Create a copy of current editing values
            const newEditingValues = { ...editingValues };

            if (checked) {
               // When checking, set to full finalOsAmount (same logic as handleSelectAll)
               const amount = parseFloat(
                  currentEntry.finalOsAmount
                     ? currentEntry.finalOsAmount + currentEntry?.amount
                     : currentEntry.osAmount + currentEntry?.amount,
               );
               newEditingValues[index] = isNaN(amount) ? 0 : amount;
               newCheckedItems[index] = true;
            } else {
               // When unchecking, reset to 0 and remove from editing values
               delete newEditingValues[index];
               newCheckedItems[index] = false;
            }

            // Calculate total amount using the same logic as handleSelectAll
            const totalAmount = pendingVoucher.reduce((sum, voucher, idx) => {
               if (newCheckedItems[idx]) {
                  // If there's an editing value, use it; otherwise use finalOsAmount
                  if (newEditingValues[idx] !== undefined) {
                     return sum + newEditingValues[idx];
                  }
                  // Fallback to finalOsAmount or amount (same priority as handleSelectAll)
                  const voucherAmount = parseFloat(voucher.finalOsAmount ? voucher.finalOsAmount : voucher.osAmount);
                  return sum + (isNaN(voucherAmount) ? 0 : voucherAmount);
               }
               return sum;
            }, 0);

            // Update editing values and received amount
            setEditingValues(newEditingValues);
            setReceivedAmount(totalAmount);
            setTempReceivedAmount(totalAmount);

            return newCheckedItems;
         });
      },
      [pendingVoucher, isEditingAmount, editingValues, setReceivedAmount],
   );

   const handleEditValueChange = (index, newValue) => {
      // Allow empty string input
      if (newValue === '') {
         setEditingValues((prev) => ({
            ...prev,
            [index]: prev[index] || pendingVoucher[index].netAmount || '',
         }));
         return;
      }

      // Convert from "₹ 100" format to numeric value
      const numericValue = parseFloat(newValue.replace(/[^\d.]/g, ''));
      const entry = pendingVoucher[index];

      // Handle NaN by setting a fallback value
      const validNumericValue = isNaN(numericValue) ? '' : numericValue;

      // Validate that the new value is valid and doesn't exceed the outstanding amount
      if (validNumericValue === '' || (validNumericValue >= 0 && validNumericValue <= parseFloat(entry.netAmount))) {
         // Update editing values
         setEditingValues((prev) => ({
            ...prev,
            [index]: validNumericValue,
         }));

         // Calculate total received amount from all editing values
         const updatedEditingValues = {
            ...editingValues,
            [index]: validNumericValue,
         };

         // Update checkbox state based on the edited value
         setCheckedItems((prevCheckedItems) => {
            const newCheckedItems = [...prevCheckedItems];

            if (validNumericValue === parseFloat(entry.netAmount)) {
               // Full checkbox if edited value matches net amount
               newCheckedItems[index] = true;
            } else if (validNumericValue > 0 && validNumericValue < parseFloat(entry.netAmount)) {
               // Partial/indeterminate checkbox if value is less than net amount
               newCheckedItems[index] = true;
            } else if (validNumericValue === 0) {
               // Unchecked if value is zero
               newCheckedItems[index] = false;
            }

            return newCheckedItems;
         });

         const totalReceivedAmount = pendingVoucher.reduce((sum, voucher, idx) => {
            // If the voucher is checked or has an edited value
            if (checkedItems[idx]) {
               // If this voucher has a custom editing value, use that
               if (updatedEditingValues[idx] !== undefined) {
                  return sum + updatedEditingValues[idx];
               }
               // Otherwise use the full outstanding amount
               return sum + parseFloat(voucher.netAmount);
            }
            return sum;
         }, 0);

         // Set the new total received amount
         setReceivedAmount(totalReceivedAmount);
      }
   };

   const handleEditSubmit = (index) => {
      const entry = pendingVoucher[index];

      // Close the editor for this specific index
      setIsEditing((prev) => ({
         ...prev,
         [index]: false,
      }));

      // Ensure `editingValues[index]` is empty if user cleared it
      if (editingValues[index] === '') {
         setEditingValues((prev) => {
            const updatedValues = { ...prev };
            delete updatedValues[index]; // Remove key if empty
            return updatedValues;
         });
      }

      // Update checkbox state based on the final edited value
      setCheckedItems((prevCheckedItems) => {
         const newCheckedItems = [...prevCheckedItems];
         const editedValue = editingValues[index];

         if (editedValue === parseFloat(entry.netAmount)) {
            // Full checkbox if edited value matches net amount
            newCheckedItems[index] = true;
         } else if (editedValue > 0 && editedValue < parseFloat(entry.netAmount)) {
            // Partial/indeterminate checkbox if value is less than net amount
            newCheckedItems[index] = true;
         } else if (editedValue === 0 || editedValue === undefined) {
            // Unchecked if value is zero or undefined
            newCheckedItems[index] = false;
         }

         return newCheckedItems;
      });
   };

   const handleReceivedAmountChange = (e) => {
      // Check if the value is empty (which happens after backspace)
      // const value = e.target.value;

      // if (isEditingAmount) {
      //    // Allow empty string and any numeric input when editing
      //    if (value === '') {
      //       setTempReceivedAmount('');
      // } else {
      //    setTempReceivedAmount(value);
      // }
      // }
      if (e.target.value === '') {
         setTempReceivedAmount(0);
         return;
      }

      // Use the raw value from the input
      // const value = parseInt(e.target.value);
      const value = parseFloat(e.target.value);
      if (!isNaN(value)) {
         setTempReceivedAmount(value);
      }
   };

   // Handle when user completes entering an amount (Enter/Tab/blur)
   const handleReceivedAmountComplete = () => {

      setIsEditingAmount(false);

      const newAmount = tempReceivedAmount;

      // Update states
      setReceivedAmount(newAmount);
      setFormData((prevFormData) => ({
         ...prevFormData,
         amount: newAmount || 0,
      }));

      // CRITICAL FIX: Call auto-selection logic here
      if (pendingVoucher.length > 0 && newAmount > 0) {

         let remainingToAllocate = newAmount;
         const newCheckedItems = new Array(pendingVoucher.length).fill(false);
         const newEditingValues = {};

         // Auto-allocate the amount starting from the first transaction
         for (let i = 0; i < pendingVoucher.length; i++) {
            const voucher = pendingVoucher[i];
            const voucherAmount = parseFloat(voucher.osAmount2 ? voucher.osAmount2 : voucher.osAmount);

            if (remainingToAllocate <= 0) {
               // No more amount to allocate
               break;
            }

            if (remainingToAllocate >= voucherAmount) {
               // Full payment for this voucher
               newCheckedItems[i] = true;
               newEditingValues[i] = voucherAmount; // Set the full amount
               remainingToAllocate -= voucherAmount;
            } else {
               // Partial payment for this voucher
               newCheckedItems[i] = true;
               newEditingValues[i] = remainingToAllocate;
               remainingToAllocate = 0;
            }
         }

         // Update checked items and editing values
         setCheckedItems(newCheckedItems);
         setEditingValues(newEditingValues);
      } else if (newAmount <= 0) {
         // If amount is 0 or negative, uncheck all
         setCheckedItems(new Array(pendingVoucher.length).fill(false));
         setEditingValues({});
      }
   };

   // Modified Select All checkbox handler
   const handleSelectAll = (isChecked) => {
      // Create a new array of checked items
      const newCheckedItems = new Array(pendingVoucher.length).fill(isChecked);

      // Create a new object to store editing values
      const newEditingValues = {};

      // Calculate the new total
      const newTotal = isChecked
         ? pendingVoucher.reduce((sum, voucher, idx) => {
            // When checked, set the full net amount for each voucher
            if (isChecked) {
               // Set full net amount in editing values
               newEditingValues[idx] = parseFloat(voucher.osAmount2 ? voucher.osAmount2 : voucher.osAmount);
               return sum + parseFloat(voucher.osAmount2 ? voucher.osAmount2 : voucher.osAmount);
            } else {
               // Otherwise use the full outstanding amount
               return sum + parseFloat(0);
            }
            // return sum;
         }, 0)
         : 0;

      // Update state
      setCheckedItems(newCheckedItems);
      setEditingValues(newEditingValues);
      setReceivedAmount(newTotal);
      setTempReceivedAmount(newTotal);
   };

   const checkLastDoc = async () => {
      // Double protection using both state and ref
      if (isProcessing || processingRef.current) {
         return;
      }

      // Set flags to prevent multiple calls
      setIsProcessing(true);
      processingRef.current = true;

      try {
         const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

         const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');

         function formatDate(dateStr) {
            if (!dateStr) return '';
            const [day, month, year] = dateStr.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
         }
         const data = {
            companyId: Number(companyId),
            daybookId: Number(formData.daybookId),
            docNumber: formData.docNumber.toString(),
            // txnType: transactionType === 'payment' ? 1 : 0,
            txnType: formData?.txnType,
            type: isBankPage ? 14 : 13,
            fromDate: fromDate,
            toDate: toDate,
            ...(formData.id && { id: formData.id }),
         };

         const res = await dispatch(checkLastDocNumberVoucher(data));

         if (res && res.code === 1 && res.data?.isError) {
            Swal.fire({
               title: res?.data?.message,
               showCancelButton: true,
               confirmButtonText: 'Yes',
               cancelButtonText: 'No',
               cancelButtonColor: '#d33',
               confirmButtonColor: '#3085d6',
               allowOutsideClick: false, // Prevent closing by clicking outside
               allowEscapeKey: false, // Prevent closing with ESC key
            }).then(async (result) => {
               if (result.isConfirmed) {
                  const newFormData = { ...formData };
                  newFormData.docNumber = res.data?.newDocNo;
                  setFormData(newFormData);
                  await handleFormSubmit(newFormData);
               }
               // Reset flags after SweetAlert
               setIsProcessing(false);
               processingRef.current = false;
            });
         } else {
            await handleFormSubmit();
            // Reset flags
            setIsProcessing(false);
            processingRef.current = false;
         }
      } catch (error) {
         console.error('Error in checkLastDoc:', error);
         // Reset flags on error
         setIsProcessing(false);
         processingRef.current = false;
      }
   };

   const handleFormSubmit = async (newformData) => {
      const finalformData = newformData ? newformData : formData;

      const selectedTransactions = pendingVoucher
         .map((entry, index) => {
            if (!checkedItems[index]) return null;
            return {
               drDocHeaderId: entry.salesId || 0,
               drDaybookId: entry.salesDaybookId || 0,
               amount: editingValues[index] !== undefined ? editingValues[index] : parseFloat(entry.amount),
               notes: '',
            };
         })
         .filter(Boolean);
      const payload = {
         ...finalformData,
         companyId: parseInt(localStorage.getItem('companyId')),
         daybookId: parseInt(finalformData.daybookId) || 0,
         docNumber: (parseInt(finalformData?.docNumber) || 1).toString(),
         // docNumber: parseInt(finalformData?.docNumber) || 1,
         // txnType: parseInt(`${transactionType === 'payment' ? 1 : 0}`),
         txnDate: finalformData.txnDate || new Date().toISOString().split('T')[0],
         accountId: parseInt(finalformData.accountId) || 0,
         amount: parseFloat(receivedAmount) || finalformData.amount,
         outAdjustments: selectedTransactions,
         chequeNo: Number(finalformData?.chequeNo),
         // outAdjustment: finalformData.outAdjustments
      };

      // ✅ Only include these fields in final payload
      const allowedFields = [
         'id',
         'companyId',
         'daybookId',
         'docNumber',
         'txnType',
         'txnDate',
         'accountId',
         'amount',
         'brokerId',
         'supplierId',
         'chequeNo',
         'transactionNo',
         'bankId',
         'bankBranchId',
         'particulars',
         'depositeDate',
         'clearingDate',
         'tdsApplicable',
         'tdsAccountId',
         'tdsLimit',
         'tdsRate',
         'tdsCess',
         'tdsSurcharge',
         'tdsAmount',
         'tdsCessAmount',
         'tdsSurchargeAmount',
         'tdsHCessAmount',
         'tdsInterestAmount',
         'tdsPenaltyAmount',
         'tdsOthersAmount',
         'notes1',
         'notes2',
         'notes3',
         'notes4',
         'notes5',
         'userNote',
         'taxableValue',
         'GSTAmount',
         'stateOfSupply',
         'isRCM',
         'GSTSubTxnType',
         'HSNSACId',
         'typeofSupply',
         'partyBillNo',
         'GSTTxnType',
         'outAdjustments',
         'chequeDate',
      ];

      const getDefaultValue = (key) => {
         const defaults = {
            supplierId: 0,
            chequeNo: 0,
            particulars: '',
            notes1: '',
            notes2: '',
            notes3: '',
            notes4: '',
            notes5: '',
            userNote: '',
            taxableValue: '',
            GSTAmount: 0,
            stateOfSupply: 0,
            GSTSubTxnType: 0,
            HSNSACId: 0,
            typeofSupply: 0,
            partyBillNo: 0,
            GSTTxnType: 0,
            tdsApplicable: false,
            tdsAccountId: 0,
            tdsLimit: 0,
            tdsRate: 0,
            tdsCess: 0,
            tdsSurcharge: 0,
            tdsAmount: 0,
            tdsCessAmount: 0,
            tdsSurchargeAmount: 0,
            tdsHCessAmount: 0,
            tdsInterestAmount: 0,
            tdsPenaltyAmount: 0,
            tdsOthersAmount: 0,
            isRCM: false,
         };
         return defaults[key] ?? null;
      };

      const cleanedPayload = {};
      allowedFields.forEach((key) => {
         cleanedPayload[key] = payload[key] !== undefined ? payload[key] : getDefaultValue(key);
      });

      if (!isTransaction) {
         delete cleanedPayload.outAdjustments;
      }

      if (finalformData.id) {
         cleanedPayload.id = finalformData.id;
      }

      cleanedPayload.amount = parseFloat(cleanedPayload.amount);
      // cleanedPayload.txnType = transactionType === 'payment' ? 1 : 0;
      cleanedPayload.txnType = formData?.txnType;
      try {
         // handleSave(payload); // Ensure finalformData updates
         const res = await dispatch(updateVoucher(cleanedPayload));
         // await dispatch(updateVoucher(payload));
         setCheckedItems([]); // Uncheck all transactions
         setReceivedAmount(0); // Reset received amount
         setEditingValues({});
         setFormData({});
         // // Refresh the data
         //   // Reset form data
         handleClearData();
         setIsOutstandingModalOpen(false);
         dispatch(
            getBankVoucher({
               type: DAYBOOK_TYPE.BANK,
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit,
               companyId: companyId,
               search: searchQuery,
               sortBy: sorting.length ? sorting[0]?.id : 'id',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
            }),
         );
         if (res && res.code === 1) {
            if (user?.loginhistory?.companyId) {
               dispatch(
                  getDaybook({
                     companyId: Number(user?.loginhistory?.companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getDaybookForPayments({
                     type: isBankPageTrue ? DAYBOOK_TYPE.BANK : DAYBOOK_TYPE.CASH,
                     companyId: Number(user?.loginhistory?.companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getItem({
                     companyId: user?.loginhistory.companyId,
                     sortBy: 'name',
                     sortOrder: 'asc',
                     ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getAccount({
                     compId: Number(user?.loginhistory?.companyId),
                     accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getAccountForCashBank({
                     compId: Number(user?.loginhistory?.companyId),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               fetchBankVoucherData && fetchBankVoucherData();
            }
         }
         // isOutstandingModalClose();
      } catch (error) {
         console.error('Error submitting form:', error);
         toast.error('Error submitting form');
      }
   };

   const handleTestData = async () => {
      try {
         await validationSchema.validate(formData, { abortEarly: false });
         setErrors({});
         if (parseFloat(formData.amount) === 0) {
            toast.error('Received Amount cannot be zero');
            return;
         }
         checkLastDoc();
         // ✅ proceed to submit
      } catch (err) {
         if (err.inner && err.inner.length > 0) {
            const validationErrors = {};
            err.inner.forEach((e) => {
               validationErrors[e.path] = e.message;
            });
            setErrors(validationErrors);
            toast.error(err.inner[0].message);
         }
         return;
      }
   };

   useEffect(() => {
      if (lastVoucherData && lastVoucherData.docNumber && formData.daybookId) {
         setFormData((prev) => ({
            ...prev,
            docNumber: parseInt(lastVoucherData.docNumber) + 1,
         }));
      }
      // else {
      //    setFormData((prev) => ({
      //       ...prev,
      //       docNumber: 1, // Automatically select the only available option
      //    }));
      // }
   }, [lastVoucherData]);

   useEffect(() => {
      if (user?.loginhistory?.companyId) {
         dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }

      return () => { };
   }, [dispatch, user?.loginhistory?.companyId]);

   return (
      <Modal
         isOpen={isOutstandingModalOpen}
         onClose={() => {
            handleClearData(); // cleanup
            setIsOutstandingModalOpen(false); // close modal
         }}
         closeOnEsc={false}
         size="4xl">
         <ModalOverlay />
         <ModalContent
            bg={useColorModeValue('white', '#2d3748')}
            color={useColorModeValue('gray.800', 'white')}
            borderRadius="20px"
            p={5}
            boxShadow="lg">
            <ModalHeader fontSize="24px" fontWeight="600" mb={4}>
               <Grid templateColumns="repeat(5, 1fr)" gap={4}>
                  <GridItem colSpan={2}>
                     {`${formData.id ? 'Update' : 'New'} ${isBankPageTrue ? 'Bank' : 'Cash'} ${formData.txnType === 1 ? 'Payment' : 'Receive'
                        }`}{' '}
                     {formData?.docNumber ? `#${parseInt(formData?.docNumber)}` : '1'}
                  </GridItem>
                  <GridItem>
                     <Flex>
                        <Checkbox isChecked={isTransaction} onChange={() => setIsTransaction(!isTransaction)}>
                           Transactions
                        </Checkbox>

                        <Text
                           as="span"
                           fontSize="sm"
                           fontWeight="normal"
                           position={'absolute'}
                           ml={'15%'}
                           color={daybookbalance > 0 ? 'green.500' : 'red.500'}>
                           {typeof daybookbalance === 'number'
                              ? (() => {
                                 const amount = Math.abs(daybookbalance).toFixed(2);
                                 const [whole, decimal] = amount.split('.');

                                 return (
                                    <>
                                       Balance: ₹{whole}.
                                       <Text as="span" fontSize="xs" verticalAlign="baseline">
                                          {decimal}
                                       </Text>{' '}
                                       {daybookbalance > 0 ? 'DB' : 'CR'}
                                    </>
                                 );
                              })()
                              : 'Balance: Nil'}
                        </Text>
                        <Text
                           as="span"
                           fontSize="sm"
                           fontWeight="normal"
                           position={'absolute'}
                           mt={'3%'}
                           ml={'15%'}
                           color={adjustmentVoucherBalanace > 0 ? 'green.500' : 'red.500'}>
                           {typeof adjustmentVoucherBalanace === 'number'
                              ? (() => {
                                 const amount = Math.abs(adjustmentVoucherBalanace).toFixed(2);
                                 const [whole, decimal] = amount.split('.');

                                 return (
                                    <>
                                       Adj Vou. Balance: ₹{whole}.
                                       <Text as="span" fontSize="xs" verticalAlign="baseline">
                                          {decimal}
                                       </Text>{' '}
                                       {adjustmentVoucherBalanace > 0 ? 'DB' : 'CR'}
                                    </>
                                 );
                              })()
                              : 'Adj Vou. Balance: Nil'}
                        </Text>
                     </Flex>
                  </GridItem>
               </Grid>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <Grid templateColumns="repeat(2, 1fr)" gap={6}>
                  <Grid>
                     <GridItem>
                        <FormControl>
                           <InputField
                              name="txnDate"
                              label="DATE"
                              ref={txnDateRef}
                              type="date"
                              // value={formData.txnDate || ''}
                              value={formData.txnDate ? formData.txnDate.split('T')[0] : ''}
                              onChange={(e) => setFormData({ ...formData, txnDate: e.target.value })}
                              errorName="txnDate" // Add this if you have validation errors for this field
                              errors={errors}
                              required={false} // Set to true if this field is required
                              bg={useColorModeValue('gray.100', '#2d3748')}
                              borderRadius="12px"
                              fontSize="18px"
                              height="50px"
                              px="20px"
                              onKeyDown={(e) => {
                                 if (e.key === 'Enter') {
                                    e.preventDefault();
                                    docNumberRef.current?.focus();
                                 } else if (e.key === 'Tab') {
                                    e.preventDefault();
                                    if (e.shiftKey) {
                                    } else {
                                       docNumberRef.current?.focus();
                                    }
                                 }
                              }}
                              color={textColor}
                              onFocus={() => handleFocus('date')}
                              onBlur={handleBlur}
                           />
                        </FormControl>
                     </GridItem>
                     <GridItem paddingTop="20px">
                        <FormControl>
                           {renderDynamicDropdown(
                              'daybookId',
                              isBankPageTrue ? 'Bank Daybook' : 'Cash Daybook',
                              daybookTypeData || [],
                              {
                                 value: formData.daybookId || '',
                                 onChange: (value) => {
                                    setFormData({
                                       ...formData,
                                       daybookId: value,
                                    });

                                    const fromDate = localStorage.getItem('selectedFy_start_date');
                                    const toDate = localStorage.getItem('selectedFy_end_date');

                                    function formatDate(dateStr) {
                                       const [day, month, year] = dateStr.split('/');
                                       return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                                    }

                                    dispatch(
                                       lastVoucherDetails({
                                          companyId: Number(companyId),
                                          daybookId: Number(value),
                                          // txnType: transactionType === 'payment' ? 1 : 0,
                                          txnType: formData?.txnType,
                                          type: isBankPage ? 14 : 13,
                                          fromDate: formatDate(fromDate),
                                          toDate: formatDate(toDate),
                                       }),
                                    );
                                 },
                                 openfrom: 'daybook', // This enables "Add" functionality if needed
                                 placeholder: isBankPageTrue ? 'Select Bank Daybook' : 'Select Cash Daybook',
                                 color: textColor,
                                 bg: useColorModeValue('gray.100', '#2d3748'),
                                 borderRadius: '12px',
                                 fontSize: '18px',
                                 height: '50px',
                                 ref: daybookRef,
                                 nextRef: accountRef,
                                 showCustomNoOptions: true,
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                       accountRef.current?.focus();
                                       e.preventDefault();
                                    } else if (e.key === 'Tab') {
                                       e.preventDefault();
                                       if (e.shiftKey) {
                                          docNumberRef.current?.focus();
                                       } else {
                                          accountRef.current?.focus();
                                       }
                                    }
                                 },
                              },
                              errors,
                              textColor,
                              false, // Not required (based on your original implementation)
                              isBankPageTrue ? 'Select Bank Account' : 'Select Cash Account',
                           )}
                        </FormControl>
                     </GridItem>
                     <GridItem paddingTop="20px">
                        <AccountSelect
                           ref={accountRef}
                           name="accountId"
                           options={filteredAccountData}
                           label="Account"
                           // value={formData?.accountId || singleVoucher?.accountId || null}
                           value={formData?.accountId || null}
                           errors={{}}
                           errorName=""
                           isClearable
                           isSearchable
                           onChange={(value) => {
                              // handleAccount('accountId', value);
                              setSelectedAccount(value);
                              handleAccountSelect(value);
                           }}
                           onKeyDown={(e) => handleKeyDown(e, receivedAmtRef, daybookRef)}
                           showCustomNoOptions={true}
                           openfrom="salesdaybook"
                           glGroup={targetGlGroup}
                        // errors={errors}
                        />
                     </GridItem>
                  </Grid>
                  <Grid>
                     <FormControl>
                        <div
                           style={{
                              position: 'relative',
                              height: '50px',
                              marginTop: '5px',
                           }}>
                           <InputField
                              ref={docNumberRef}
                              name="docNumber"
                              label="Doc Number"
                              placeholder="Doc Number"
                              // value={singleVoucher?.docNumber || formData.docNumber || ''}
                              value={formData.docNumber || ''}
                              onChange={(e) => setFormData({ ...formData, docNumber: e.target.value })}
                              onFocus={() => {
                                 setIsDocNumberFocused(true);
                              }}
                              onBlur={() => {
                                 setIsDocNumberFocused(false);
                              }}
                              onKeyDown={(e) => {
                                 if (e.key === 'Enter') {
                                    e.preventDefault();
                                    daybookRef.current?.focus();
                                 } else if (e.key === 'Tab') {
                                    e.preventDefault();
                                    if (e.shiftKey) {
                                       txnDateRef.current?.focus();
                                    } else {
                                       daybookRef.current?.focus();
                                    }
                                 }
                              }}
                              color={textColor}
                              bg={useColorModeValue('gray.100', '#2d3748')}
                              borderRadius="12px"
                              fontSize="18px"
                              height="50px"
                              px="20px"
                              readOnly={false}
                              disabled={isNavigating}
                           />

                           {isNavigating && (
                              <div
                                 style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '12px',
                                    color: 'gray.500',
                                 }}>
                                 Loading...
                              </div>
                           )}
                        </div>
                     </FormControl>

                     <GridItem paddingTop="10px">
                        <FormControl>
                           <div
                              style={{
                                 position: 'relative',
                                 height: '50px',
                                 marginTop: '5px',
                              }}>
                              <Input
                                 id="amount1"
                                 type="text"
                                 placeholder="Pending Amount"
                                 value={selectedAccount?.amt ? selectedAccount?.amt : totalPendingAccount}
                                 // value={formData?.pendingAmt || totalPendingAccount}
                                 readOnly
                                 color={textColor}
                                 bg={useColorModeValue('gray.100', '#2d3748')}
                                 borderRadius="12px"
                                 fontSize="18px"
                                 height="50px"
                                 px="20px"
                              />
                           </div>
                        </FormControl>
                     </GridItem>
                     <GridItem paddingTop="20px">
                        <FormControl>
                           <div style={{ position: 'relative', height: '50px', marginTop: '5px' }}>
                              <Input
                                 id="receivedAmount"
                                 type="number"
                                 placeholder={transactionType === 'payment' ? 'Payment Amount' : 'Received Amount'}
                                 name="amount"
                                 ref={receivedAmtRef}
                                 value={
                                    isEditingAmount
                                       ? tempReceivedAmount === 0 || tempReceivedAmount === '0' || tempReceivedAmount === ''
                                          ? ''
                                          : tempReceivedAmount
                                       : formData.amount === 0 || formData.amount === '0' || formData.amount === ''
                                          ? ''
                                          : formData.amount
                                 }
                                 onFocus={() => {
                                    setIsEditingAmount(true);
                                    setTempReceivedAmount(formData.amount || receivedAmount);
                                 }}
                                 onChange={(e) => {
                                    const value = e.target.value;

                                    // Update temp amount when editing
                                    if (isEditingAmount) {
                                       const numValue = value === '' ? '' : parseFloat(value) || 0;
                                       setTempReceivedAmount(numValue);

                                       // Update formData.amount in real-time
                                       setFormData((prevFormData) => ({
                                          ...prevFormData,
                                          amount: numValue,
                                       }));

                                       // Update receivedAmount state
                                       setReceivedAmount(numValue === '' ? 0 : numValue);
                                    }
                                 }}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();

                                       // Call auto-selection BEFORE moving focus
                                       handleReceivedAmountComplete();

                                       // Small delay to ensure state updates before moving focus
                                       setTimeout(() => {
                                          if (isBankPage) {
                                             chequeNoRef.current?.focus();
                                          } else {
                                             notesRef.current?.focus();
                                          }
                                       }, 50);
                                    } else if (e.key === 'Tab') {
                                       e.preventDefault();

                                       // Call auto-selection BEFORE moving focus
                                       handleReceivedAmountComplete();

                                       // Small delay to ensure state updates before moving focus
                                       setTimeout(() => {
                                          if (e.shiftKey) {
                                             accountRef.current?.focus();
                                          } else {
                                             if (isBankPage) {
                                                chequeNoRef.current?.focus();
                                             } else {
                                                notesRef.current?.focus();
                                             }
                                          }
                                       }, 50);
                                    }
                                 }}
                                 onBlur={(e) => {

                                    // Only call handleReceivedAmountComplete if not moving focus programmatically
                                    // Check if blur is caused by our own focus change
                                    const relatedTarget = e.relatedTarget;
                                    const isProgrammaticBlur =
                                       relatedTarget === chequeNoRef.current ||
                                       relatedTarget === notesRef.current ||
                                       relatedTarget === accountRef.current;

                                    if (!isProgrammaticBlur) {
                                       handleReceivedAmountComplete();
                                    }
                                 }}
                                 onWheel={(e) => e.target.blur()}
                                 color={textColor}
                                 bg={useColorModeValue('gray.100', '#2d3748')}
                                 borderRadius="12px"
                                 fontSize="18px"
                                 height="50px"
                                 px="20px"
                              />
                              <label
                                 htmlFor="receivedAmount"
                                 style={{
                                    position: 'absolute',
                                    top: formData.amount ? '-10px' : '15px',
                                    left: '15px',
                                    transform: formData.amount
                                       ? 'translateX(10px) scale(0.75)'
                                       : 'translateX(0) scale(1)',
                                    color: textColor,
                                    transition: 'transform 200ms, color 200ms',
                                    pointerEvents: 'none',
                                    height: '25px',
                                    width: 'auto',
                                    backgroundColor: useColorModeValue('white', '#2d3748'),
                                    borderRadius: '2vh',
                                    display: 'inline-block',
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                 }}>
                                 {transactionType === 'payment' ? 'PAYMENT AMOUNT' : 'RECEIVED AMOUNT'}
                              </label>
                           </div>
                        </FormControl>
                     </GridItem>
                  </Grid>
                  {isBankPage ? (
                     <>
                        <GridItem paddingTop="0px">
                           <FormControl>
                              <div
                                 style={{
                                    position: 'relative',
                                    height: '50px',
                                    marginTop: '5px',
                                 }}>
                                 <Input
                                    ref={chequeNoRef}
                                    id="chequeNo"
                                    type="text"
                                    placeholder="Enter Cheque Number"
                                    name="chequeNo"
                                    value={formData.chequeNo || ''}
                                    onChange={(e) => setFormData({ ...formData, chequeNo: Number(e.target.value) })}
                                    color={textColor}
                                    // bg={useColorModeValue('gray.100', '#2d3748')}
                                    borderRadius="12px"
                                    _placeholder={{ color: 'transparent' }}
                                    fontSize="18px"
                                    height="50px"
                                    px="20px"
                                    onFocus={() => handleFocus('chequeNo')}
                                    onBlur={handleBlur}
                                    onKeyDown={(e) => {
                                       if (e.key === 'Enter') {
                                          e.preventDefault();
                                          chequeDateRef.current?.focus();
                                       } else if (e.key === 'Tab') {
                                          e.preventDefault();
                                          if (e.shiftKey) {
                                             receivedAmtRef.current?.focus();
                                          } else {
                                             chequeDateRef.current?.focus();
                                          }
                                       }
                                    }}
                                 />
                                 <label
                                    htmlFor="chequeNo"
                                    style={{
                                       position: 'absolute',
                                       top: '-10px',
                                       left: '15px',
                                       transform: 'translateX(10px) scale(0.75)',
                                       color: textColor,
                                       transition: 'transform 200ms, color 200ms',
                                       pointerEvents: 'none',
                                       zIndex: 100,
                                       height: '25px',
                                       width: 'auto',
                                       // backgroundColor: useColorModeValue('white', '#2d3748'),
                                       borderRadius: '2vh',
                                       display: 'inline-block',
                                       paddingLeft: 10,
                                       paddingRight: 10,
                                    }}>
                                    CHEQUE NUMBER
                                 </label>
                              </div>
                           </FormControl>
                        </GridItem>

                        <GridItem paddingTop="0px">
                           <FormControl>
                              <div
                                 style={{
                                    position: 'relative',
                                    height: '50px',
                                    marginTop: '5px',
                                 }}>
                                 <Input
                                    ref={chequeDateRef}
                                    id="chequeDate"
                                    type="date"
                                    placeholder="Enter Cheque Date"
                                    name="chequeDate"
                                    value={formData.chequeDate || ''}
                                    onChange={(e) => setFormData({ ...formData, chequeDate: e.target.value })}
                                    color={textColor}
                                    // bg={useColorModeValue('gray.100', '#2d3748')}
                                    borderRadius="12px"
                                    _placeholder={{ color: 'transparent' }}
                                    fontSize="18px"
                                    height="50px"
                                    px="20px"
                                    onFocus={() => handleFocus('chequeDate')}
                                    onBlur={handleBlur}
                                    onKeyDown={(e) => {
                                       if (e.key === 'Enter') {
                                          e.preventDefault();
                                          notesRef.current?.focus();
                                       } else if (e.key === 'Tab') {
                                          e.preventDefault();
                                          if (e.shiftKey) {
                                             chequeNoRef.current?.focus();
                                          } else {
                                             notesRef.current?.focus();
                                          }
                                       }
                                    }}
                                 />
                                 <label
                                    htmlFor="chequeDate"
                                    style={{
                                       position: 'absolute',
                                       top: '-10px',
                                       left: '15px',
                                       transform: 'translateX(10px) scale(0.75)',
                                       color: textColor,
                                       transition: 'transform 200ms, color 200ms',
                                       pointerEvents: 'none',
                                       zIndex: 100,
                                       height: '25px',
                                       width: 'auto',
                                       // backgroundColor: useColorModeValue('white', '#2d3748'),
                                       borderRadius: '2vh',
                                       display: 'inline-block',
                                       paddingLeft: 10,
                                       paddingRight: 10,
                                    }}>
                                    CHEQUE DATE
                                 </label>
                              </div>
                           </FormControl>
                        </GridItem>
                     </>
                  ) : null}
               </Grid>
               {isTransaction && (
                  <Grid>
                     Transactions
                     <Grid border="2px solid" color="gray.200" borderRadius="10px">
                        <Grid display="flex" padding="10px 0px 10px 0px">
                           <Grid width="10%" justifyContent="center">
                              {pendingVoucher.length > 0 && (
                                 <Checkbox
                                    isChecked={checkedItems.length > 0 && checkedItems.every(Boolean)}
                                    isIndeterminate={
                                       checkedItems.some(Boolean) &&
                                       (!checkedItems.every(Boolean) ||
                                          pendingVoucher.some(
                                             (voucher, idx) =>
                                                checkedItems[idx] &&
                                                editingValues[idx] !== undefined &&
                                                editingValues[idx] < parseFloat(voucher.amount),
                                          ))
                                    }
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                 />
                              )}
                           </Grid>
                           <Grid width="26%" color="blackAlpha.900">
                              <label>Description</label>
                           </Grid>
                           <Grid width="15%" color="blackAlpha.900">
                              <label>Net Amount</label>
                           </Grid>
                           <Grid width="20%" color="blackAlpha.900">
                              <label>Pending Amt</label>
                           </Grid>
                           <Grid width="15%" color="blackAlpha.900">
                              <label>Max Adj Amt</label>
                           </Grid>
                           <Grid width="14%" color="blackAlpha.900">
                              <label>{formData.txnType === 1 ? 'Payment' : 'Receive'}</label>
                           </Grid>
                        </Grid>

                        {pendingVoucher.length > 0 &&
                           pendingVoucher.map((entry, index) => {
                              const today = new Date();
                              const transactionDate = new Date(entry.transactionAt);
                              const timeDifference = today - transactionDate;
                              const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
                              const day = String(transactionDate.getDate()).padStart(2, '0');
                              const month = String(transactionDate.getMonth() + 1).padStart(2, '0');
                              const year = transactionDate.getFullYear();
                              const formattedTransactionDate = `${day}/${month}/${year}`;

                              const fullAmount = entry?.finalOsAmount
                                 ? entry?.finalOsAmount + entry?.amount
                                 : entry?.osAmount + entry?.amount;
                              const currentValue = editingValues[index];
                              const isFullyChecked = checkedItems[index] && currentValue === fullAmount;
                              const isIndeterminate =
                                 checkedItems[index] && currentValue !== undefined && currentValue !== fullAmount;

                              return (
                                 <Grid
                                    display="flex"
                                    borderTop="1px solid"
                                    padding="10px 0px 10px 0px"
                                    alignItems="center"
                                    id={`grid-${index}`}
                                    key={`voucher-${index}`}>
                                    <Grid width="10%" justifyContent="center">
                                       <Checkbox
                                          id={`checkbox-${index}`}
                                          isChecked={isFullyChecked}
                                          isIndeterminate={isIndeterminate}
                                          onChange={(e) => {
                                             handleDynamicCheckboxChange(index, e.target.checked);
                                          }}
                                       />
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="26%">
                                       <Grid fontSize="15px" color="black">
                                          <label>
                                             {formData.txnType === 1 ? `Purchase#` : 'Sale#'}
                                             {entry.docno}
                                          </label>
                                       </Grid>
                                       <Grid fontSize="10px" display="flex">
                                          <Grid>
                                             <label>{formattedTransactionDate}</label>
                                          </Grid>
                                          <Grid paddingLeft="10px">
                                             <label>( Days {daysDifference})</label>
                                          </Grid>
                                       </Grid>
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="15%">
                                       <label>₹{entry?.netAmount}</label>
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="20%" display="flex" alignItems="center">
                                       <label>₹{entry?.finalOsAmount ? entry?.finalOsAmount : entry?.osAmount}</label>
                                       <Grid
                                          border="2px solid"
                                          color={formData.txnType === 1 ? 'orange' : 'green.600'}
                                          borderColor={formData.txnType === 1 ? 'orange' : 'green.600'}
                                          borderRadius="7px"
                                          padding="2px 7px"
                                          marginLeft="10px">
                                          {formData.txnType === 1 ? 'Payable' : 'Receivable'}
                                       </Grid>
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="15%">
                                       {/* <label>₹{entry?.finalOsAmount ? entry?.finalOsAmount + entry?.amount : entry?.osAmount + entry?.amount}</label> */}
                                       <label>₹{entry?.osAmount2 ? entry?.osAmount2 : entry?.osAmount}</label>
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="14%" display="flex">
                                       <Grid width="80%">
                                          <Grid>
                                             {isEditing[index] ? (
                                                <Input
                                                   autoFocus
                                                   value={
                                                      editingValues[index] !== undefined
                                                         ? `₹ ${editingValues[index]}`
                                                         : ''
                                                   }
                                                   // onChange={(e) => handleEditValueChange(index, e.target.value)}
                                                   onChange={(e) => {
                                                      handleEditValueChange(index, e.target.value);

                                                      // Dynamically update checkbox state based on edited value
                                                      const inputValue = parseFloat(
                                                         e.target.value.replace(/[^\d.]/g, ''),
                                                      );
                                                      const netAmount = entry.finalOsAmount
                                                         ? parseFloat(entry.finalOsAmount)
                                                         : parseFloat(entry.osAmount);
                                                      setCheckedItems((prevCheckedItems) => {
                                                         const newCheckedItems = [...prevCheckedItems];

                                                         if (inputValue === netAmount) {
                                                            // Full checkbox if edited value matches net amount
                                                            newCheckedItems[index] = true;
                                                         } else if (inputValue > 0 && inputValue < netAmount) {
                                                            // Partial/indeterminate checkbox if value is less than net amount
                                                            newCheckedItems[index] = true;
                                                         } else if (inputValue === 0) {
                                                            // Unchecked if value is zero
                                                            newCheckedItems[index] = false;
                                                         }

                                                         return newCheckedItems;
                                                      });
                                                   }}
                                                   onBlur={() => handleEditSubmit(index)}
                                                   onKeyDown={(e) => e.key === 'Enter' && handleEditSubmit(index)}
                                                   size="sm"
                                                />
                                             ) : (
                                                <label>
                                                   {editingValues[index] !== undefined
                                                      ? `₹ ${editingValues[index]}`
                                                      : checkedItems[index]
                                                         ? `₹ 0`
                                                         : `₹ ${entry.isAdjustment ? 0 : 0}`}
                                                </label>
                                             )}
                                          </Grid>
                                          {editingValues[index] !== undefined &&
                                             editingValues[index] <
                                             (parseFloat(
                                                entry.finalOsAmount ? entry.finalOsAmount : entry?.osAmount,
                                             ) || entry.amount) && (
                                                <label style={{ color: 'orange', fontSize: '14px' }}>
                                                   Remaining: ₹{' '}
                                                   {(
                                                      parseFloat(
                                                         entry.finalOsAmount
                                                            ? entry.finalOsAmount + entry?.amount
                                                            : entry?.osAmount + entry?.amount,
                                                      ) - editingValues[index]
                                                   ).toFixed(2)}
                                                </label>
                                             )}
                                       </Grid>

                                       <Grid width="20%">
                                          <img
                                             src={editIcon}
                                             alt="edit icon"
                                             width="20px"
                                             height="20px"
                                             style={{ cursor: 'pointer' }}
                                             onClick={() => {
                                                // Update only this specific entry's edit state using index
                                                setIsEditing((prev) => ({
                                                   ...prev,
                                                   [index]: true,
                                                }));
                                                setEditingValues((prev) => ({
                                                   ...prev,
                                                   [index]: parseFloat(editingValues[index] ? editingValues[index] : 0), // Ensure it's a number
                                                }));
                                             }}
                                          />
                                       </Grid>
                                       <MdInfoOutline
                                          width="20px"
                                          height="20px"
                                          style={{ cursor: 'pointer' }}
                                          onClick={(e) => {
                                             if (formData.id) {
                                                dispatch(
                                                   getAdjustedVoucher({
                                                      saleId: entry.salesId,
                                                      daybookId: entry.salesDaybookId,
                                                      txnType: formData.txnType,
                                                      voucherId: formData.id,
                                                   }),
                                                );
                                             }
                                             onOpen();
                                          }}
                                       />
                                    </Grid>
                                 </Grid>
                              );
                           })}
                     </Grid>
                  </Grid>
               )}
               {/* <GridItem colSpan={2}>
                  <FormControl>
                     <div
                        style={{
                           position: 'relative',
                           height: '50px',
                           marginTop: '5px',
                           marginBottom: 25,
                        }}>
                        <Textarea
                           id="notes"
                           ref={notesRef}
                           placeholder="Enter Notes"
                           value={formData?.userNote || ''}
                           onChange={(e) =>
                              setFormData({
                                 ...formData,
                                 userNote: e.target.value,
                              })
                           }
                           onKeyDown={(e) => {
                              if (e.key === 'Enter' && !e.shiftKey) {
                                 e.preventDefault();
                                 createRef.current?.focus();
                              } else if (e.key === 'Tab') {
                                 e.preventDefault();
                                 if (e.shiftKey) {
                                    if (isBankPage) {
                                       chequeDateRef.current?.focus();
                                    } else {
                                       receivedAmtRef.current?.focus();
                                    }
                                 } else {
                                    createRef.current?.focus();
                                 }
                              }
                           }}
                           name="userNote"
                           color={textColor}
                           bg={useColorModeValue('gray.100', '#2d3748')}
                           borderRadius="12px"
                           _placeholder={{ color: 'transparent' }}
                           fontSize="18px"
                           height="50px"
                           px="20px"
                           onFocus={() => handleFocus('notes')}
                           onBlur={handleBlur}
                        />
                        <label
                           htmlFor="notes"
                           style={{
                              position: 'absolute',
                              top: focusedInput === 'notes' || (currentRow?.notes ? true : false) ? '-10px' : '15px',
                              left: '15px',
                              transform:
                                 focusedInput === 'notes' || (currentRow?.notes ? true : false)
                                    ? 'translateX(10px) scale(0.75)'
                                    : 'translateX(0) scale(1)',
                              color: textColor,
                              transition: 'transform 200ms, color 200ms',
                              pointerEvents: 'none',
                              zIndex: 100,
                              height: '25px',
                              width: 'auto',
                              backgroundColor: useColorModeValue('white', '#2d3748'),
                              borderRadius: '2vh',
                              display: 'inline-block',
                              paddingLeft: 10,
                              paddingRight: 10,
                           }}>
                           NOTES
                        </label>
                     </div>
                  </FormControl>
               </GridItem> */}
               <GridItem colSpan={2} mt={4}>
                  <TextareaField
                     ref={notesRef}
                     name="userNote"
                     label="NOTES"
                     // placeholder="Enter Notes"
                     value={formData?.userNote || ''}
                     onChange={(e) =>
                        setFormData({
                           ...formData,
                           userNote: e.target.value,
                        })
                     }
                     onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                           e.preventDefault();
                           createRef.current?.focus();
                        } else if (e.key === 'Tab') {
                           e.preventDefault();
                           if (e.shiftKey) {
                              if (isBankPage) {
                                 chequeDateRef.current?.focus();
                              } else {
                                 receivedAmtRef.current?.focus();
                              }
                           } else {
                              createRef.current?.focus();
                           }
                        }
                     }}
                     fontSize="18px"
                     height="50px"
                     px="20px"
                  />
               </GridItem>
               <Modal isCentered onClose={onClose} isOpen={isOpen} motionPreset="slideInBottom">
                  <ModalOverlay />
                  <ModalContent>
                     <ModalHeader>Adjusted Vouchers Entries</ModalHeader>
                     <ModalCloseButton />
                     <ModalBody>
                        <Table variant="simple" size="sm" border="1px solid" borderColor="gray.200">
                           <Thead>
                              <Tr>
                                 <Th border="1px solid" borderColor="gray.200">
                                    Doc No
                                 </Th>
                                 <Th border="1px solid" borderColor="gray.200">
                                    Description
                                 </Th>
                                 <Th border="1px solid" borderColor="gray.200">
                                    Voucher Amount
                                 </Th>
                                 <Th border="1px solid" borderColor="gray.200">
                                    Net Amount
                                 </Th>
                              </Tr>
                           </Thead>
                           <Tbody>
                              {adjustedVoucher.map((voucher, index) => (
                                 <Tr key={index}>
                                    <Td border="1px solid" borderColor="gray.200">
                                       {voucher.docno}
                                    </Td>
                                    <Td border="1px solid" borderColor="gray.200">
                                       S{voucher.salesId}-DOC{voucher.docno}
                                    </Td>
                                    <Td border="1px solid" borderColor="gray.200">
                                       {voucher.VoucherAmount}
                                    </Td>
                                    <Td border="1px solid" borderColor="gray.200">
                                       {voucher.netAmount}
                                    </Td>
                                 </Tr>
                              ))}
                           </Tbody>
                        </Table>
                     </ModalBody>
                     <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={onClose}>
                           Close
                        </Button>
                     </ModalFooter>
                  </ModalContent>
               </Modal>
            </ModalBody>
            <ModalFooter>
               <Button
                  ref={createRef}
                  onClick={handleTestData}
                  variant="darkBrand"
                  color="white"
                  fontSize="sm"
                  fontWeight="500"
                  borderRadius="full"
                  px="24px"
                  py="5px"
                  _active={{ bg: '#06b' }}
                  mr={5}
                  _focus={{ outlineColor: 'blue.500 ' }}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        cancelRef.current?.focus();
                     }
                  }}>
                  Edit
               </Button>
               <Button
                  ref={cancelRef}
                  variant="ghost"
                  onClick={() => setIsOutstandingModalOpen(false)}
                  _focus={{ outlineColor: 'blue.500 ' }}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        createRef.current?.focus();
                     }
                  }}>
                  Cancel
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default PaymentcaseFormEdit;
